// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { activeSkin } from './skin';

/** The hole-map colours of the active skin. Values live in theme/skins/<name>.ts. */
export const mapColors = activeSkin.map;

export default mapColors;
